import React, { useState, useEffect } from 'react';
import './PostJob.css';
import { Slidar } from '../AdminDashbord/Slidar';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";

const PostJob = () => {
  const [jobData, setJobData] = useState({
    name: '',
    title: '',
    description: '',
    qualifications: '',
    field: '',
    skills: '',
    location: '',
    type: 'Full Time',
    salary: '',
  });
  const [jobs, setJobs] = useState([]);
  const [editId, setEditId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);

  // Sidebar toggle state for mobile
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await fetch('/api/jobs');
      const data = await res.json();
      setJobs(data);
    } catch (err) {
      console.error('Failed to fetch jobs:', err);
    }
  };

  const handleChange = (e) => {
    setJobData({ ...jobData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const url = editId
        ? `/api/jobs/${editId}`
        : '/api/jobs';
      const method = editId ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jobData),
      });

      const result = await response.json();

      if (response.ok) {
        alert(editId ? '✅ Job updated!' : '✅ Job posted!');
        setJobData({
          name: '',
          title: '',
          description: '',
          qualifications: '',
          field: '',
          skills: '',
          location: '',
          type: 'Full Time',
          salary: '',
        });
        setEditId(null);
        fetchJobs();
      } else {
        alert('❌ ' + result.message);
      }
    } catch (error) {
      console.error('Submit error:', error);
      alert('❌ Error submitting job.');
    }
  };

  const handleEdit = (job) => {
    setJobData(job);
    setEditId(job._id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this job?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(`/api/jobs/${id}`, {
        method: 'DELETE',
      });
      const data = await res.json();
      if (res.ok) {
        alert('🗑️ Job deleted.');
        fetchJobs();
      } else {
        alert('❌ Failed to delete job: ' + data.message);
      }
    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  return (
    <div className="job-container-flex">

      {/* Hamburger for mobile */}
      {/* <button
        className="menu-icon"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        ☰
      </button> */}

      {/* Sidebar */}
      {/* <div className={`sidebar ${sidebarOpen ? 'active' : ''}`}>
        <Slidar />
      </div> */}
{/* Sidebar Toggle Button */}
{/* <button 
  className="menu-toggle-btn" 
  onClick={() => setSidebarOpen(!sidebarOpen)}
>
  {sidebarOpen ? '✖' : '☰'}
</button>

<div className={`sidebar ${sidebarOpen ? 'active' : ''}`}>
  <div className="slidar-container">
    <Slidar />
  </div>
</div> */}
  <div style={{marginTop:'10px'}}>
        <Slidar />
      </div>

      {/* Main Content */}
      <div className="job-content">

        <div className="nagaraja" style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button
            className="toggle-job-button"
            style={{ marginTop: '40px', position: 'relative' }}
            onClick={() => {
              setShowForm(!showForm);
              if (!showForm) {
                setEditId(null);
                setJobData({
                  name: '',
                  title: '',
                  description: '',
                  qualifications: '',
                  field: '',
                  skills: '',
                  location: '',
                  type: 'Full Time',
                  salary: '',
                });
              }
            }}
          >
            {showForm ? '❌ Close Form' : '➕ Add Job'}
          </button>
        </div>

        <div className="job-search-container">
          <input
            type="text"
            placeholder=" Search by Job Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="job-search-input"
          />
        </div>

        {showForm && (
          <form onSubmit={handleSubmit} className="job-form-grid">

            <div className="form-row">
              <div className="form-group">
                <label>Job Name</label>
                <input type="text" name="name" value={jobData.name} onChange={handleChange} required className="job-input" />
              </div>

              <div className="form-group">
                <label>Company Name</label>
                <input type="text" name="title" value={jobData.title} onChange={handleChange} required className="job-input" />
              </div>
            </div>

            <div className="form-row-full">
              <label>Job Description</label>
              <textarea name="description" value={jobData.description} onChange={handleChange} rows="4" required className="job-input job-textarea" />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Required Qualifications</label>
                <select name="qualifications" value={jobData.qualifications} onChange={handleChange} required className="job-input">
                  <option value="">-- Select Qualification --</option>
                  <option value="SSLC">SSLC</option>
                  <option value="PUC">PUC</option>
                  <option value="Diploma">Diploma</option>
                  <option value="UG">UG</option>
                  <option value="PG">PG</option>
                  <option value="PhD">PhD</option>
                </select>
              </div>

              <div className="form-group">
  <label>Experience</label>
  <select
    name="field"
    value={jobData.field}
    onChange={handleChange}
    required
    className="job-input"
  >
    <option value="">Select Experience</option>
    <option value="Freshers">Freshers</option>
    <option value="1 to 2">1 to 2</option>
    <option value="2 to 5">2 to 5</option>
    <option value="5 to 15">5 to 15</option>
     <option value="Above">Above</option>
  </select>
</div>

            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Required knowledge</label>
                <input type="text" name="skills" value={jobData.skills} onChange={handleChange} placeholder="e.g., JavaScript, React" required className="job-input" />
              </div>

              <div className="form-group">
                <label>Location</label>
                <input type="text" name="location" value={jobData.location} onChange={handleChange} required className="job-input" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Job Type</label>
                <select name="type" value={jobData.type} onChange={handleChange} className="job-input">
                  <option>Full Time</option>
                  <option>Part Time</option>
                  <option>Internship</option>
                  <option>Contract</option>
                </select>
              </div>

              <div className="form-group">
                <label>Salary (₹ per month)</label>
                <input
                  type="number"
                  name="salary"
                  value={jobData.salary}
                  onChange={handleChange}
                  className="job-input"
                  onKeyDown={e => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              </div>
            </div>

            <div className="form-row-full">
              <button type="submit" className="job-button">{editId ? 'Update Job' : 'Submit Job'}</button>
            </div>

          </form>
        )}

        {/* Display Jobs */}
        <h2 className="job-heading">Posted Jobs</h2>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Job Name</th>
                <th>Company Name</th>
                <th>Description</th>
                <th>Qualifications</th>
                <th>Mode of Work</th>
                <th>Skills</th>
                <th>Location</th>
                <th>Type</th>
                <th>Salary</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobs
                .filter((job) =>
                  job.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((job) => (
                  <tr key={job._id}>
                    <td>{job.name}</td>
                    <td>{job.title}</td>
                    <td>{job.description}</td>
                    <td>{job.qualifications}</td>
                    <td>{job.field}</td>
                    <td>{job.skills}</td>
                    <td>{job.location}</td>
                    <td>{job.type}</td>
                    <td>{job.salary}</td>
                    <td>
                      <div className="action-buttons">
                        <button className="icon-button" onClick={() => handleEdit(job)} title="Edit Job"><FaEdit /></button>
                        <button
                          className="icon-button delete"
                          onClick={() => handleDelete(job._id)}
                          title="Delete Job"
                        >
                          <MdDelete style={{ color: "#000" }} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PostJob;
